import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatBadgeModule } from '@angular/material/badge';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTabsModule } from '@angular/material/tabs';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { SatDatepickerModule, SatNativeDateModule } from 'saturn-datepicker';
import { MatSliderModule } from '@angular/material/slider';
import { MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatMenuModule } from '@angular/material/menu';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDateFormats, MatNativeDateModule, MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';

// Inserir todos os módulos do material desejados nesse import. Também adicione os mesmos módulos em import e repita em export.
// tslint:disable-next-line: max-line-length


export const MY_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
// documentação: https://material.angular.io/

const MATERIAL_MODULES = [
  MatMenuModule,
  MatSnackBarModule,
  MatGridListModule,
  MatButtonModule,
  MatCardModule,
  MatToolbarModule,
  MatAutocompleteModule,
  MatIconModule,
  MatFormFieldModule,
  MatSlideToggleModule,
  MatInputModule,
  MatTableModule,
  MatSliderModule,
  SatDatepickerModule,
  SatNativeDateModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatRadioModule,
  MatProgressSpinnerModule,
  MatListModule,
  MatTabsModule,
  MatSidenavModule,
  MatButtonToggleModule,
  MatCheckboxModule,
  MatBottomSheetModule,
  MatProgressBarModule,
  MatSelectModule,
  FormsModule,
  MatTooltipModule,
  MatPaginatorModule,
  MatSortModule,
  MatBadgeModule,
  DragDropModule,
  MatDialogModule
];

@NgModule({
  imports: [
    // BrowserAnimationsModule,
    MATERIAL_MODULES
  ],
  exports: [
    // BrowserAnimationsModule,
    MATERIAL_MODULES
  ],
  entryComponents: [ // Necessário para que possam ser instanciados numa janela de diálogo do Google Material.

  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    // { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ],
})
export class MaterialModule { }
